import type {
  AuthenticationResponseJSON,
  RegistrationJSON,
} from '@passwordless-id/webauthn/dist/esm/types';

import { toBufferSource } from './string/toBufferSource';

const prfParam = 'SORARE_PRF'; // random hardcoded constant

export const prf = {
  eval: {
    first: new TextEncoder().encode(prfParam),
  },
};

export const prfResult = (
  response: AuthenticationResponseJSON | RegistrationJSON
) => {
  return toBufferSource(response.clientExtensionResults.prf?.results?.first);
};
